import {
  SERVICE_ERROR, SERVICE_REQUEST, SERVICE_SUCCESS, SERVICE_UPDATE, SERVICE_STATUS_UPDATE,
} from './types';

const initialState = {
  data   : {},
  error  : null,
  loading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SERVICE_ERROR:
      return {
        ...state,
        error  : action.error,
        loading: false,
      };
    case SERVICE_REQUEST:
      return {
        ...state,
        error  : null,
        loading: true,
      };
    case SERVICE_SUCCESS:
      return {
        ...state,
        data   : action.data,
        loading: false,
      };
    case SERVICE_UPDATE:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.data,
          from: {
            ...state.data.from,
            ...action.data.from,
            poi: state.data.from.poi,
          },
          order: {
            ...state.data.order,
          },
          to: {
            ...state.data.to,
            ...action.data.to,
            poi: state.data.to.poi,
          },
        },
        loading: false,
      };
    case SERVICE_STATUS_UPDATE:
      return {
        ...state,
        loading: false,
        data   : {
          ...state.data,
          ...(action.data && {
            agent : action.data.agent,
            status: action.data.status,
            paxs  : action.data.paxs,
            log   : action.data.log,
          }),
        },
      };
    default:
      return state;
  }
}
